<template>
  <!-- <label>
    <input type="radio" :checked="checked" :value="value" @change="change" />
    {{ label }}
  </label> -->

  <div class="radio-button">
    <div class="radio-button__circle" :class="{ 'radio-button__circle--checked': checked }" @click="change">
    </div>
    <div class="radio-button__label">{{ label }}</div>
  </div>
</template>

<script>
  export default {
    model: {
      prop: 'modelValue',
      event: 'change'
    },
    props: {
      value: {
        required: true
      },
      modelValue: {
        default: ''
      },
      label: {
        type: String,
        required: true
      }
    },
    computed: {
      checked() {
        return this.modelValue == this.value
      }
    },
    methods: {
      change() {
        this.$emit('change', this.value)
      }
    }
  }
</script>

<style lang="scss">
  .radio-button
  {
    display: inline-flex;
    align-items: center;

    margin-right: 50px;

    color: #003862;

    &__circle
    {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      padding: 6px;

      border: 2px solid #003862;
      border-radius: 12px;
      background-clip: content-box;

      &--checked
      {
        background-color: #003862;
      }
    }

    &__label
    {
    }
  }
</style>
